export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out on a per block basis. Users can withdraw at any time.`,
  },
  {
    question: `What is the inflation?`,
    answer: `The QCK first year inflation is set for 25% and expected to drop by 25% per year. Notably, QCK does not have a rigid inflation. The QCK token aims to be an adaptive token meaning governance can change vital parameters like token inflation making it flexible in responding to market and ecosystem conditions.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 21 days unbonding period when unstaking QCK from the network. Users will not earn rewards and will be susceptible to slashing during unbonding.`,
  },
  {
    question: `How to restake?`,
    answer: `Users may manually withdraw rewards and restake to compound their returns. Enabling auto-compound via REstake by Eco Stake is also an available option.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Staking risks do apply including slashing involved for downtime and double signing.`,
  },
];
